import {
    createContext
} from 'react';

export const SavedTopicContext = createContext(null); // eslint-disable-line
